import React, { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  it: {
    nav: { home: "Home", solutions: "Soluzioni", products: "Prodotti", how: "Come funziona", forWho: "Per chi è", faq: "FAQ", contacts: "Contatti", cta: "Richiedi informazioni" },
    hero: {
      badge: "Smart Parcel Lockers · Programma BOXLY 2026",
      title1: "La nuova generazione", title2: "di Smart Locker.",
      subtitle: "La soluzione intelligente per condomini, residence, nuovi sviluppi immobiliari e complessi aziendali.",
      cta1: "Scopri di più", cta2: "Richiedi informazioni",
    },
    marquee: "Consegne autonome — Ritiro H24 — Meno gestione manuale — Ordine e sicurezza —",
    about: {
      label: "Chi siamo",
      title: "Costruiamo l'infrastruttura delle consegne del futuro.",
      p1: "Boxly nasce per semplificare la gestione delle consegne in condomini, residence, complessi residenziali e aziendali. Uno smart parcel locker installato direttamente presso la struttura elimina attese e il bisogno di un portiere sempre presente.",
      p2: "Non un semplice armadietto: una rete di locker connessi, gestita da software proprietario, pensata per crescere insieme a property manager, costruttori immobiliari e complessi aziendali.",
      chapters: [
        { n: "01", t: "Visione", d: "Rendere ogni consegna semplice, tracciata e disponibile 24 ore su 24." },
        { n: "02", t: "Tecnologia", d: "Hardware modulare e piattaforma cloud proprietaria, integrabile con i principali corrieri." },
        { n: "03", t: "Scala", d: "Un'architettura pensata per crescere: nuovi modelli, nuove integrazioni, zero riprogettazioni." },
      ],
    },
    problem: {
      label: "Il problema",
      title: "La consegna tradizionale è rotta.",
      items: [
        { t: "Consegne fallite", d: "Pacchi che tornano indietro perché nessuno è in casa al momento della consegna." },
        { t: "Destinatario assente", d: "Orari di consegna rigidi che non si adattano alla vita delle persone." },
        { t: "Costi elevati", d: "Tentativi ripetuti e resi che fanno lievitare i costi della logistica." },
        { t: "Portierato assente", d: "Sempre meno stabili dispongono di un servizio di portineria attivo." },
        { t: "Perdita di tempo", d: "File, attese e appuntamenti mancati per un semplice ritiro." },
        { t: "Poca sicurezza", d: "Pacchi lasciati davanti alla porta, esposti a furti e danni." },
      ],
    },
    solution: {
      label: "La soluzione",
      title: "Un ecosistema Smart Locker completo.",
      intro: "Una rete di locker connessi e un software che orchestra ogni consegna, dal deposito al ritiro.",
      items: [
        { t: "Consegna autonoma", d: "Il corriere deposita il pacco nello scomparto sicuro dedicato." },
        { t: "Ritiro H24", d: "Il destinatario ritira quando vuole, senza vincoli di orario." },
        { t: "Notifiche", d: "Avvisi in tempo reale via email al destinatario ad ogni step." },
        { t: "Codice sicuro", d: "Apertura dello scomparto tramite codice univoco o QR." },
        { t: "Apertura automatica", d: "Lo sportello si apre da solo al momento del ritiro." },
        { t: "Gestione cloud", d: "Dashboard centralizzata per amministratori e property manager." },
      ],
    },
    how: {
      label: "Come funziona",
      title: "Sei passaggi. Zero attese.",
      steps: [
        { t: "Deposito pacco", d: "Il corriere deposita il pacco in uno scomparto Boxly disponibile." },
        { t: "Associazione consegna", d: "Il sistema associa la consegna al destinatario corretto." },
        { t: "Notifica cliente", d: "Il destinatario riceve subito l'avviso con il codice di ritiro." },
        { t: "Ritiro autonomo", d: "Ritiro in autonomia H24 tramite codice o QR." },
        { t: "Chiusura automatica", d: "Lo sportello si richiude e lo scomparto torna disponibile." },
        { t: "Tracciamento", d: "Ogni consegna resta tracciata nella dashboard cloud." },
      ],
    },
    products: {
      label: "Gamma prodotti",
      title: "Un locker per ogni esigenza.",
      subtitle: "Configurazioni modulari, indoor e outdoor, personalizzabili su misura.",
      btn: "Scopri",
      cards: [
        { n: "Smart Locker S", d: "Compatto, ideale per piccoli spazi e alto ricambio." },
        { n: "Smart Locker M", d: "Il formato più versatile per residenze e uffici." },
        { n: "Smart Locker L", d: "Ampia capacità per complessi ad alto volume." },
        { n: "Smart Locker XL", d: "Massima capienza per hub logistici e retail." },
        { n: "Locker Indoor", d: "Design elegante per hall, atri e spazi interni." },
        { n: "Locker Outdoor", d: "Resistente ad acqua, polvere e intemperie." },
        { n: "Locker Refrigerati", d: "Catena del freddo per food e prodotti farmaceutici." },
        { n: "Locker Aziendali", d: "Gestione asset, dispositivi e consegne interne." },
        { n: "Locker Condominiali", d: "Un punto di ritiro sempre disponibile per i residenti." },
        { n: "Locker Personalizzati", d: "Dimensioni, colori e branding su misura." },
      ],
    },
    sectors: {
      label: "Per chi è",
      title: "Progettato per la tua struttura.",
      items: ["Condomini", "Residence", "Nuovi sviluppi immobiliari", "Property manager", "Costruttori immobiliari", "Complessi residenziali", "Complessi aziendali", "Business Park", "Uffici", "Hotel", "Retail"],
    },
    features: {
      label: "Funzionalità",
      title: "Una piattaforma, tutto sotto controllo.",
      items: ["QR Code", "Cloud", "App Web", "API", "White Label", "Controllo remoto", "Monitoraggio", "Report", "Accesso utenti", "Notifiche email", "Integrazione Corrieri", "Dashboard admin"],
    },
    why: {
      label: "Perché Boxly",
      title: "Vantaggi concreti per la tua struttura.",
      stats: [
        { v: "H24", l: "Ritiro sempre disponibile" },
        { v: "0", l: "Attese e appuntamenti" },
        { v: "1", l: "Piattaforma cloud unificata" },
        { v: "Modulare", l: "Configurazioni su misura" },
        { v: "Scalabile", l: "Crescita per fasi" },
        { v: "White label", l: "Personalizzabile con il tuo brand" },
      ],
    },
    gallery: { label: "Galleria", title: "Boxly nel contesto reale." },
    cases: {
      label: "Programma BOXLY 2026",
      title: "Il Programma BOXLY 2026.",
      intro: "Il Programma BOXLY 2026 è dedicato a complessi residenziali, property manager, sviluppatori immobiliari e aziende interessati a integrare una soluzione smart per la gestione delle consegne.",
      cards: [
        { tag: "Condomini & Residence", t: "Un punto di ritiro sempre attivo", d: "Sostituisce la necessità di un portiere sempre presente e semplifica la gestione dei pacchi." },
        { tag: "Nuovi sviluppi", t: "Integrato nel progetto immobiliare", d: "Pensato fin dalla progettazione per property manager e sviluppatori immobiliari." },
        { tag: "Complessi aziendali", t: "Consegne interne ordinate", d: "Uffici, business park e complessi aziendali con un unico punto di ricezione." },
      ],
      cta: "Partecipa al Programma BOXLY 2026",
    },
    faq: {
      label: "FAQ",
      title: "Domande frequenti.",
      items: [
        { q: "Cos'è uno Smart Locker Boxly?", a: "È un armadietto intelligente installato presso la tua struttura che permette a corrieri e residenti/utenti di depositare e ritirare pacchi in autonomia, H24." },
        { q: "A chi è destinato?", a: "A condomini, residence, complessi residenziali, nuovi sviluppi immobiliari, property manager, complessi aziendali e business park." },
        { q: "Come ritiro il mio pacco?", a: "Ricevi una notifica via email con un codice univoco (o QR). Lo inserisci sul locker e lo sportello dedicato si apre automaticamente." },
        { q: "I locker funzionano anche all'esterno?", a: "Sì, sono disponibili modelli outdoor progettati per resistere ad acqua, polvere e intemperie." },
        { q: "Posso conservare prodotti freddi?", a: "Sì, i modelli refrigerati sono pensati per la catena del freddo (food delivery e prodotti farmaceutici)." },
        { q: "Come vengono gestite le consegne?", a: "Tutto viene gestito da una dashboard cloud centralizzata: monitoraggio consegne, gestione utenti e report." },
        { q: "È adatto al mio condominio?", a: "I locker condominiali sono progettati proprio per sostituire la necessità di un portiere sempre presente, offrendo un punto di ritiro attivo per tutti i residenti." },
        { q: "È possibile personalizzare i locker?", a: "Sì, offriamo personalizzazione di dimensioni, colori, branding e configurazioni white label per property manager e aziende." },
        { q: "Come vengono protetti i dati?", a: "Il sistema utilizza connessioni cifrate e infrastruttura conforme alle normative europee sulla protezione dei dati." },
        { q: "Come posso avere maggiori informazioni?", a: "Compila il form nella sezione Contatti oppure scrivici a info@boxlyitalia.it: ti ricontattiamo per valutare insieme la soluzione più adatta." },
      ],
    },
    ctaFinal: { title: "Pronto a rivoluzionare la gestione delle consegne?", sub: "Il Programma BOXLY 2026 è aperto a strutture, property manager e sviluppatori immobiliari interessati.", btn: "Partecipa al Programma BOXLY 2026" },
    form: {
      title: "Richiedi informazioni",
      sub: "Compila il modulo, ti ricontattiamo il prima possibile.",
      name: "Nome e cognome", email: "Email", company: "Azienda / Condominio / Struttura", phone: "Telefono (facoltativo)",
      structure: "Tipologia struttura", structurePlaceholder: "Seleziona una tipologia",
      units: "N° indicativo di unità/appartamenti (facoltativo)", message: "Messaggio",
      consent: "Inviando la richiesta dichiari di aver letto la",
      consentLink: "Privacy Policy",
      consentEnd: "di BOXLY.",
      submit: "Invia richiesta", sending: "Invio in corso...",
      success: "Richiesta inviata! Ti ricontattiamo a breve.",
      error: "Si è verificato un errore. Riprova.",
      structures: ["Condominio", "Residence", "Nuovo sviluppo immobiliare", "Property manager / Costruttore", "Complesso residenziale", "Complesso aziendale", "Business Park", "Ufficio", "Hotel", "Retail", "Altro"],
    },
    contactInfo: { general: "Email generale", commercial: "Contatto commerciale", location: "Milano, Italia" },
    footer: {
      tagline: "Smart Parcel Lockers.",
      brandOfIt: "BOXLY è un brand di NEWNETWORK S.R.L.S.",
      contact: "Contatti", social: "Social", legal: "Legale",
      privacy: "Privacy Policy", cookie: "Cookie Policy", contactLink: "Contatti",
      legalInfo: "Informazioni societarie",
      legalHolder: "Titolare — Informazioni societarie",
      rights: "Tutti i diritti riservati.",
      generalEmail: "Email generale",
      commercialEmail: "Contatto commerciale",
      companyPlaceholder: "Ragione sociale: NEWNETWORK S.R.L.S.  ·  P.IVA: 10290721215",
    },
    cookie: {
      banner: "Utilizziamo cookie tecnici necessari al funzionamento del sito e cookie di analisi/registrazione sessione per migliorare il servizio. Puoi accettare o rifiutare i cookie non essenziali.",
      accept: "Accetta tutto", reject: "Rifiuta non essenziali", more: "Cookie Policy",
    },
  },
  en: {
    nav: { home: "Home", solutions: "Solutions", products: "Products", how: "How it works", forWho: "Who it's for", faq: "FAQ", contacts: "Contact", cta: "Request information" },
    hero: {
      badge: "Smart Parcel Lockers · BOXLY 2026 Program",
      title1: "The next generation", title2: "of Smart Lockers.",
      subtitle: "The intelligent solution for residential complexes, condominiums, new real-estate developments and corporate campuses.",
      cta1: "Discover more", cta2: "Request information",
    },
    marquee: "Autonomous deliveries — 24/7 pickup — Less manual handling — Order & security —",
    about: {
      label: "About us",
      title: "We build the delivery infrastructure of the future.",
      p1: "Boxly was created to simplify parcel management in condominiums, residences, residential and corporate complexes. A smart parcel locker installed on-site removes waiting and the need for a permanent concierge.",
      p2: "Not a simple box: a network of connected lockers, driven by proprietary software, designed to grow with property managers, real-estate developers and corporate campuses.",
      chapters: [
        { n: "01", t: "Vision", d: "Make every delivery simple, tracked and available around the clock." },
        { n: "02", t: "Technology", d: "Modular hardware and a proprietary cloud platform, integrable with major couriers." },
        { n: "03", t: "Scale", d: "An architecture built to grow: new models, new integrations, zero redesigns." },
      ],
    },
    problem: {
      label: "The problem",
      title: "Traditional delivery is broken.",
      items: [
        { t: "Failed deliveries", d: "Parcels sent back because nobody is home at delivery time." },
        { t: "Recipient absent", d: "Rigid delivery windows that don't fit people's lives." },
        { t: "High costs", d: "Repeated attempts and returns that inflate logistics costs." },
        { t: "No concierge", d: "Fewer and fewer buildings have an active concierge service." },
        { t: "Wasted time", d: "Queues, waiting and missed appointments for a simple pickup." },
        { t: "Low security", d: "Parcels left at the door, exposed to theft and damage." },
      ],
    },
    solution: {
      label: "The solution",
      title: "A complete Smart Locker ecosystem.",
      intro: "A network of connected lockers and software that orchestrates every delivery, from drop-off to pickup.",
      items: [
        { t: "Autonomous delivery", d: "The courier drops the parcel in a dedicated secure compartment." },
        { t: "24/7 pickup", d: "The recipient collects whenever they want, no constraints." },
        { t: "Notifications", d: "Real-time email alerts to the recipient at every step." },
        { t: "Secure code", d: "Compartment opening via unique code or QR." },
        { t: "Auto opening", d: "The door opens by itself at pickup time." },
        { t: "Cloud management", d: "Centralized dashboard for administrators and property managers." },
      ],
    },
    how: {
      label: "How it works",
      title: "Six steps. Zero waiting.",
      steps: [
        { t: "Parcel drop-off", d: "The courier drops the parcel in an available Boxly compartment." },
        { t: "Delivery match", d: "The system links the delivery to the right recipient." },
        { t: "Customer notified", d: "The recipient instantly receives the pickup code by email." },
        { t: "Self-pickup", d: "Self-service pickup 24/7 with code or QR." },
        { t: "Auto close", d: "The door closes and the compartment becomes available again." },
        { t: "Tracking", d: "Every delivery is tracked in the cloud dashboard." },
      ],
    },
    products: {
      label: "Product range",
      title: "A locker for every need.",
      subtitle: "Modular configurations, indoor and outdoor, fully customizable.",
      btn: "Explore",
      cards: [
        { n: "Smart Locker S", d: "Compact, ideal for small spaces and high turnover." },
        { n: "Smart Locker M", d: "The most versatile format for homes and offices." },
        { n: "Smart Locker L", d: "Large capacity for high-volume complexes." },
        { n: "Smart Locker XL", d: "Maximum capacity for logistics hubs and retail." },
        { n: "Indoor Locker", d: "Elegant design for lobbies and interior spaces." },
        { n: "Outdoor Locker", d: "Resistant to water, dust and harsh weather." },
        { n: "Refrigerated Locker", d: "Cold chain for food and pharma." },
        { n: "Corporate Locker", d: "Manage assets, devices and internal deliveries." },
        { n: "Condominium Locker", d: "An always-available pickup point for residents." },
        { n: "Custom Locker", d: "Tailored dimensions, colors and branding." },
      ],
    },
    sectors: {
      label: "Who it's for",
      title: "Designed for your building.",
      items: ["Condominiums", "Residences", "New real-estate developments", "Property managers", "Real-estate developers", "Residential complexes", "Corporate complexes", "Business Parks", "Offices", "Hotels", "Retail"],
    },
    features: {
      label: "Features",
      title: "One platform, everything under control.",
      items: ["QR Code", "Cloud", "Web App", "API", "White Label", "Remote control", "Monitoring", "Reports", "User access", "Email notifications", "Courier integration", "Admin dashboard"],
    },
    why: {
      label: "Why Boxly",
      title: "Concrete benefits for your building.",
      stats: [
        { v: "24/7", l: "Always available pickup" },
        { v: "0", l: "Waiting or appointments" },
        { v: "1", l: "Unified cloud platform" },
        { v: "Modular", l: "Custom configurations" },
        { v: "Scalable", l: "Grow in phases" },
        { v: "White label", l: "Customizable with your brand" },
      ],
    },
    gallery: { label: "Gallery", title: "Boxly in real contexts." },
    cases: {
      label: "BOXLY 2026 Program",
      title: "The BOXLY 2026 Program.",
      intro: "The BOXLY 2026 Program is dedicated to residential complexes, property managers, real-estate developers and companies interested in integrating a smart solution for parcel management.",
      cards: [
        { tag: "Condos & Residences", t: "An always-active pickup point", d: "Replaces the need for a permanent concierge and simplifies parcel handling." },
        { tag: "New developments", t: "Built into the real-estate project", d: "Designed from the start for property managers and real-estate developers." },
        { tag: "Corporate complexes", t: "Ordered internal deliveries", d: "Offices, business parks and corporate complexes with a single delivery point." },
      ],
      cta: "Join the BOXLY 2026 Program",
    },
    faq: {
      label: "FAQ",
      title: "Frequently asked questions.",
      items: [
        { q: "What is a Boxly Smart Locker?", a: "A smart locker installed on-site that lets couriers and residents/users drop off and pick up parcels autonomously, 24/7." },
        { q: "Who is it for?", a: "Condominiums, residences, residential complexes, new real-estate developments, property managers, corporate complexes and business parks." },
        { q: "How do I collect my parcel?", a: "You receive an email notification with a unique code (or QR). Enter it on the locker and the dedicated door opens automatically." },
        { q: "Do lockers work outdoors?", a: "Yes, outdoor models are designed to withstand water, dust and harsh weather." },
        { q: "Can I store cold products?", a: "Yes, refrigerated models are designed for the cold chain (food delivery and pharma)." },
        { q: "How are deliveries managed?", a: "Everything is handled from a centralized cloud dashboard: delivery monitoring, user management and reports." },
        { q: "Is it right for my condominium?", a: "Condominium lockers are designed precisely to replace the need for a permanent concierge, offering an active pickup point for all residents." },
        { q: "Can lockers be customized?", a: "Yes, we offer customization of size, colors, branding and white-label configurations for property managers and companies." },
        { q: "How is my data protected?", a: "The system uses encrypted connections and infrastructure compliant with European data protection regulations." },
        { q: "How can I get more information?", a: "Fill in the form in the Contact section or write to info@boxlyitalia.it: we'll get back to you to evaluate the best solution together." },
      ],
    },
    ctaFinal: { title: "Ready to revolutionize delivery management?", sub: "The BOXLY 2026 Program is open to buildings, property managers and real-estate developers.", btn: "Join the BOXLY 2026 Program" },
    form: {
      title: "Request information",
      sub: "Fill in the form, we'll get back to you as soon as possible.",
      name: "Full name", email: "Email", company: "Company / Condominium / Building", phone: "Phone (optional)",
      structure: "Building type", structurePlaceholder: "Select a type",
      units: "Approx. units/apartments (optional)", message: "Message",
      consent: "By submitting this request you declare you have read the",
      consentLink: "Privacy Policy",
      consentEnd: "of BOXLY.",
      submit: "Send request", sending: "Sending...",
      success: "Request sent! We'll be in touch soon.",
      error: "Something went wrong. Please try again.",
      structures: ["Condominium", "Residence", "New real-estate development", "Property manager / Developer", "Residential complex", "Corporate complex", "Business Park", "Office", "Hotel", "Retail", "Other"],
    },
    contactInfo: { general: "General email", commercial: "Commercial contact", location: "Milan, Italy" },
    footer: {
      tagline: "Smart Parcel Lockers.",
      brandOfEn: "BOXLY is a brand of NEWNETWORK S.R.L.S.",
      brandOfIt: "BOXLY is a brand of NEWNETWORK S.R.L.S.",
      contact: "Contact", social: "Social", legal: "Legal",
      privacy: "Privacy Policy", cookie: "Cookie Policy", contactLink: "Contact",
      legalInfo: "Company information",
      legalHolder: "Controller — Company information",
      rights: "All rights reserved.",
      generalEmail: "General email",
      commercialEmail: "Commercial contact",
      companyPlaceholder: "Company: NEWNETWORK S.R.L.S.  ·  VAT ID: 10290721215",
    },
    cookie: {
      banner: "We use technical cookies necessary for the site to function and analytics/session recording cookies to improve the service. You can accept or reject non-essential cookies.",
      accept: "Accept all", reject: "Reject non-essential", more: "Cookie Policy",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => (typeof window !== "undefined" && localStorage.getItem("boxly-lang")) || "it");
  const toggle = useCallback(() => setLang((l) => {
    const next = l === "it" ? "en" : "it";
    try { localStorage.setItem("boxly-lang", next); } catch (e) {}
    return next;
  }), []);
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
